<template>
  <table
    border="0"
    cellpadding="0"
    cellspacing="0"
    class="w-full border-collapse"
  >
    <thead>
      <tr>
        <th
          v-if="selectable"
          class="bg-gradient-to-b from-gray-500 to-gray-600"
          width="30"
        >{{ '' }}</th>
        <th
          v-for="(col, index) in allCols"
          :key="index"
          :align="col.align"
          :class="['font-medium leading-4 text-white select-none', {
            'bg-gradient-to-b hover:from-gray-400 hover:to-gray-500 cursor-pointer': col.sortable,
            'bg-gradient-to-b from-gray-400 to-gray-500': col.value === orderByField,
            'bg-gradient-to-b from-gray-500 to-gray-600': col.value !== orderByField
          }]"
          :width="col.width"
          @click="$emit('sort', col)"
        >
          <div :class="['p-4', { 'flex justify-between': col.sortable }]">
            <div v-html="col.text"></div>
            <FontAwesomeIcon
              v-if="col.sortable"
              :icon="['far', orderByField === col.value ? orderByDescending ? 'sort-down' : 'sort-up' : 'sort']"
              class="ml-2"
            />
          </div>
        </th>
        <th
          v-if="expandable"
          class="bg-gradient-to-b from-gray-500 to-gray-600"
          width="30"
        >{{ '' }}</th>
      </tr>
    </thead>

    <POrderGridRow
      v-for="(order, index) in orders"
      :key="index"
      :cols="cols"
      :expandable="expandable"
      :expanded="expandAll"
      :index="index"
      :nested="nested"
      :order="order"
      :selectable="selectable"
      :selected="isSelected(order)"
      @click="$emit('click', order, $event)"
      @select="$emit('select', order)"
    ></POrderGridRow>

    <tfoot v-if="showFooter">
      <tr>
        <td
          :colspan="allCols.length + 1"
          class="sticky bottom-0"
        >
          <div class="px-4 py-2 bg-white border-t border-gray-300 'text-gray-800">
            <div
              v-if="loading"
              class="flex items-center"
            >
              <FontAwesomeIcon
                :icon="['far', 'spinner']"
                pulse
              />
              <div class="ml-2">
                <PTranslation k="Common.General.PleaseWait" />
              </div>
            </div>
            <template v-else>
              {{ $t("POrderGridTable.ShowingXofYOrders", { count: orders.length, total: totalCount }) }}
            </template>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import POrderGridRow from "./POrderGridRow"

import {
  forEach,
  findIndex
} from "lodash"

export default {
  name: "POrderGridTable",
  components: {
    POrderGridRow
  },
  props: {
    cols: { type: Array, required: true },
    expandAll: { type: Boolean, default: false },
    expandable: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    nested: { type: String, default: "transactions" },
    orderByDescending: { type: Boolean, default: false },
    orderByField: { type: String, default: "" },
    orders: { type: Array, default: () => [] },
    selectable: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true },
    totalCount: { type: Number, default: 0 },
    value: { type: Array, default: () => [] }
  },
  computed: {
    allCols() {
      let arr = []
      forEach(this.cols, col => {
        if (col.nested) {
          arr = arr.concat(col.nested)
        } else {
          arr.push(col)
        }
      })
      return arr
    }
  },
  methods: {
    isSelected(order) {
      return findIndex(this.value, value => value === order.id) >= 0
    },
    onSelect(order) {
      this.$emit("select", order)
    }
  }
}
</script>

<style scoped>
table {
  border: 0;
  border-spacing: 0;
  color: theme('colors.gray.700');
  font-size: theme('fontSize.xs');
}

th {
  position: sticky;
  top: 0;
  margin: 0;
  box-shadow: 1px 0 0 theme('colors.gray.600');
  border-right: 1px solid theme('colors.gray.600');
  padding: 0;
  line-height: theme('lineHeight.none');
}
</style>